import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function animateFooterIn() {
    const footer = document.querySelector('.site-footer')

    if (footer) {
        const footerContent = footer.querySelector(
            '[data-target="footer-content"]'
        )
        const contentChildren = footerContent.children

        const parallaxImg = document.querySelector(
            '[data-target="footer-parallax"]'
        )
        const svg = parallaxImg.querySelector('svg')

        const dist = document.getElementById('DistantFooter')
        const bg = document.getElementById('BackgroundFooter')
        const mg = document.getElementById('MidgroundFooter')
        const fg = document.getElementById('ForegroundFooter')

        const tl = gsap.timeline({ paused: true })

        gsap.set(contentChildren, { autoAlpha: 0 })
        gsap.set(svg, { autoAlpha: 0 })

        gsap.set(dist, {
            y: -60,
        })

        gsap.set(bg, {
            y: -30,
        })

        gsap.set(mg, {
            y: 50,
        })

        gsap.set(fg, {
            y: 70,
        })

        tl.to(parallaxImg, {
            autoAlpha: 1,
            duration: 2,
        })
            .to(
                dist,
                {
                    ease: 'power4.inOut',
                    y: 0,
                    duration: 3,
                },
                '<'
            )
            .to(
                bg,
                {
                    ease: 'power4.inOut',
                    y: 0,
                    duration: 3,
                },
                '<'
            )
            .to(
                mg,
                {
                    y: 0,
                    ease: 'power4.inOut',
                    duration: 3,
                },
                '<'
            )
            .to(
                fg,
                {
                    y: 0,
                    ease: 'power4.inOut',
                    duration: 3,
                },
                '<'
            )

        const footerObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        tl.play()
                        gsap.to(contentChildren, {
                            delay: 0.5,
                            autoAlpha: 1,
                            duration: 1,
                        })
                    } else {
                    }
                })
            },
            {
                rootMargin: '-50% 0px -50% 0px',
            }
        )
        footerObserver.observe(footer)
    }
}

export default animateFooterIn
